/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/sort-comp */
import { Button, Grid } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import { NkSelect } from '@nordkap/nordkap-ui';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import api from '../../../../infrastructure/api/api';
import { emptyGuid } from '../../../../utils/constants';
import { sortTemplates } from '../../../../utils/sorting';
import { styles } from './styles';

// Component tranformed to a Class component due to the need of passing the component scope to the parent "Templates" components
// The scope is passed to the parent component along with a callback that needs to be executed
// The callback must be executed inside this component's scope and we bind the scope in the parent component
class TemplateRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      positionTemplates: [],
      selectedTemplate: {
        positionTemplateId: '',
        archived: true,
      },
      positionCount: 0,
    };

    this.addPositionTemplateOption = this.addPositionTemplateOption.bind(this);
    this.updatePositionTemplateOption =
      this.updatePositionTemplateOption.bind(this);
    this.templateSaved = this.templateSaved.bind(this);
    this.createNewTemplate = this.createNewTemplate.bind(this);
    this.editTemplate = this.editTemplate.bind(this);
    this.archiveTemplate = this.archiveTemplate.bind(this);
    this.unarchiveTemplate = this.unarchiveTemplate.bind(this);
    this.changePositionTemplate = this.changePositionTemplate.bind(this);
    this.getTemplateOptionLabel = this.getTemplateOptionLabel.bind(this);
  }

  addPositionTemplateOption(templateListItem) {
    const newPositionTemplates = [templateListItem].concat(
      this.state.positionTemplates
    );
    const sortedPositionTemplates = sortTemplates(newPositionTemplates);
    this.setState({
      selectedTemplate: templateListItem,
      positionCount: 0,
      positionTemplates: sortedPositionTemplates,
    });
  }

  updatePositionTemplateOption(existingTemplate, savedTemplate) {
    existingTemplate.name = savedTemplate.name;
    const sortedTemplates = sortTemplates(this.state.positionTemplates);
    this.setState(prevState => ({
      ...prevState,
      positionTemplates: sortedTemplates,
      selectedTemplate: existingTemplate,
    }));
  }

  templateSaved(savedTemplate) {
    const existingTemplate = this.state.positionTemplates.find(
      pt => pt.positionTemplateId === savedTemplate.positionTemplateId
    );
    if (existingTemplate) {
      this.updatePositionTemplateOption(existingTemplate, savedTemplate);
    } else {
      this.addPositionTemplateOption(savedTemplate);
    }
  }

  componentDidMount() {
    if (this.props.positionType) {
      api
        .get(
          `positionTemplates/getAll?positionType=${this.props.positionType}`,
          this.props.enqueueSnackbar,
          this.props.t
        )
        .then(positionTemplatesResult => {
          if (
            positionTemplatesResult !== null &&
            positionTemplatesResult.length > 0
          ) {
            const sortedPositionTemplates = sortTemplates(
              positionTemplatesResult
            );
            this.setState({
              positionTemplates: sortedPositionTemplates,
              positionCount: sortedPositionTemplates[0].positionCount,
              selectedTemplate: sortedPositionTemplates[0],
            });
          }
        });
    }
  }

  createNewTemplate() {
    this.props.editTemplate(this.props.positionType, {
      isOpen: true,
      positionTemplateId: emptyGuid,
      templateSaved: this.templateSaved,
      scope: this,
    });
  }

  editTemplate() {
    this.props.editTemplate(this.props.positionType, {
      isOpen: true,
      positionTemplateId: this.state.selectedTemplate.positionTemplateId,
      templateSaved: this.templateSaved,
      scope: this,
    });
  }

  archiveTemplate() {
    api
      .put(
        `positionTemplates/archive?positionTemplateId=${this.state.selectedTemplate.positionTemplateId}`,
        {},
        this.props.enqueueSnackbar,
        this.props.t
      )
      .then(() => {
        const selectedTemplate = this.state.positionTemplates.find(
          pt =>
            pt.positionTemplateId ===
            this.state.selectedTemplate.positionTemplateId
        );
        selectedTemplate.archived = true;
        this.setState(prevState => ({
          ...prevState,
          selectedTemplate,
          positionTemplates: sortTemplates([...this.state.positionTemplates]),
        }));
      });
  }

  unarchiveTemplate() {
    api
      .put(
        `positionTemplates/unarchive?positionTemplateId=${this.state.selectedTemplate.positionTemplateId}`,
        {},
        this.props.enqueueSnackbar,
        this.props.t
      )
      .then(() => {
        const selectedTemplate = this.state.positionTemplates.find(
          pt =>
            pt.positionTemplateId ===
            this.state.selectedTemplate.positionTemplateId
        );
        selectedTemplate.archived = false;
        this.setState(prevState => ({
          ...prevState,
          selectedTemplate,
          positionTemplates: sortTemplates([...this.state.positionTemplates]),
        }));
      });
  }

  changePositionTemplate(event) {
    if (event.target.value) {
      const selectedPositionTemplate = this.state.positionTemplates.find(
        pt => pt.positionTemplateId === event.target.value
      );
      this.setState(prevState => ({
        ...prevState,
        positionCount: selectedPositionTemplate.positionCount,
        selectedTemplate: selectedPositionTemplate,
      }));
    }
  }

  getTemplateOptionLabel(positionTemplate) {
    return `${
      (positionTemplate.archived
        ? `[${this.props.t('positionTemplate.archived')}] `
        : '') + positionTemplate.name
    } ${this.props.t('fieldsAndTemplatesPage.usage', {
      positionCount: positionTemplate.positionCount,
    })}`;
  }

  render() {
    const { t, classes } = this.props;

    return (
      <>
        <Grid item container justifyContent="center" alignItems="center" xs={2}>
          <label>{t(`positionType.${this.props.positionType}`)}</label>
        </Grid>
        <Grid item container alignItems="center" xs={10}>
          <div className={classes.TemplateDropdown}>
            <NkSelect
              variant="outlined"
              name={t('positionPage.template') + this.props.positionType}
              value={this.state.selectedTemplate.positionTemplateId}
              onChange={this.changePositionTemplate}
              items={this.state.positionTemplates.map(pt => ({
                value: pt.positionTemplateId,
                title: this.getTemplateOptionLabel(pt),
              }))}
              itemPropName="value"
              itemTitlePropName="title"
              wrapper={false}
            />
          </div>
          <Button
            id="edit-position-template"
            variant="contained"
            color="primary"
            title={t('positionPage.editTemplate')}
            onClick={this.editTemplate}
            className={classes.TemplateButton}
            disabled={
              !this.state.selectedTemplate.positionTemplateId ||
              this.state.selectedTemplate.positionTemplateId === ''
            }
          >
            <EditIcon />
          </Button>
          {!this.state.selectedTemplate.archived ? (
            <Button
              id="archive-position-template"
              variant="outlined"
              color="primary"
              title={t('fieldsAndTemplatesPage.archiveTemplate')}
              onClick={this.archiveTemplate}
              className={classes.TemplateButton}
              disabled={
                !this.state.selectedTemplate.positionTemplateId ||
                this.state.selectedTemplate.positionTemplateId === ''
              }
            >
              <DeleteIcon />
            </Button>
          ) : (
            <Button
              id="unarchive-position-template"
              variant="outlined"
              color="primary"
              title={t('fieldsAndTemplatesPage.unarchiveTemplate')}
              onClick={this.unarchiveTemplate}
              className={classes.TemplateButton}
              disabled={
                !this.state.selectedTemplate.positionTemplateId ||
                this.state.selectedTemplate.positionTemplateId === ''
              }
            >
              <RestoreFromTrashIcon />
            </Button>
          )}
          <Button
            id="create-position-template"
            variant="contained"
            color="primary"
            title={t('positionPage.createTemplate')}
            onClick={this.createNewTemplate}
            className={classes.TemplateButton}
          >
            <AddIcon />
          </Button>
        </Grid>
      </>
    );
  }
}

TemplateRow.propTypes = {
  positionType: PropTypes.string,
  editTemplate: PropTypes.func,
  enqueueSnackbar: PropTypes.func,
  t: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(styles)(withSnackbar(withTranslation()(TemplateRow)));
